// 路由访问拦截

import router from './router/index'
import {
  setWebTitle
} from './utils/common-fun'

// 在访问页面之前做些什么
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token')
  let title = to.meta.title ? to.meta.title : '企业HR后台'
  let needAuth = to.meta.auth

  setWebTitle(title)
  
  // 页面需要授权，但 token 不为真，跳转到登录页让用户去登录
  if (needAuth && !token) {
    next('/login')
  } else {
    next()
  }
})